import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/hooks/use-auth";
import slotToRange from "@/utils/date/to-range";
import { BuyerAvailability, getBuyerAvailability } from "@/utils/get-buyer-availability";
import { logger } from "@/utils/logger";
import React, { useEffect, useState } from "react";
import SlotSheetOverLay from "../common/slot-sheet-overlay";
import { PrefillSlotsComp } from "./prefill-slots-comp";
import { SlotVisit } from "./slot-visit";
import { MainProps, Slot } from "./types";

// Main Component
export default function Main(props) {
  const $ = _c(34);
  const [isConfirmed, setIsConfirmed] = useState(Boolean(props.isPrefilled));
  const [shouldFill, setShouldFill] = useState(false);
  const {
    projectId,
    unitId,
    userId,
    buyerId: buId
  } = props;
  const {
    user
  } = useAuth();
  const [loading, setLoading] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [prefillData, setPrefillData] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [currentUnitData, setCurrentUnitData] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [counterSlots, setCounterSlots] = useState(t2);
  let t3;
  if ($[3] !== buId || $[4] !== user?.groups) {
    t3 = buId || (user?.groups || []).find(_temp)?.id;
    $[3] = buId;
    $[4] = user?.groups;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const buyerId = t3;
  const enabled = Boolean(userId) && Boolean(unitId) && Boolean(buyerId);
  let t4;
  let t5;
  if ($[6] !== buyerId || $[7] !== enabled || $[8] !== projectId || $[9] !== unitId) {
    t4 = () => {
      if (enabled && buyerId) {
        const now = new Date();
        setLoading(true);
        getBuyerAvailability({
          buyerId,
          ...(projectId ? {
            projectId
          } : {
            unitId
          }),
          isMobile: false
        }).then(data => {
          if (data && !("error" in data)) {
            const {
              otherBuyerSlots,
              currentBuyerSlots,
              sellerSlots
            } = data as BuyerAvailability;
            const processSlots = slots => {
              if (!slots) {
                return [];
              }
              return slots.filter(slot => new Date(slot.startTime) > now).map(_temp2);
            };
            setPrefillData(processSlots(otherBuyerSlots));
            setCurrentUnitData(processSlots(currentBuyerSlots));
            setCounterSlots(processSlots(sellerSlots));
          }
        }).catch(_temp3).finally(() => {
          setLoading(false);
        });
      }
    };
    t5 = [enabled, buyerId, projectId, unitId];
    $[6] = buyerId;
    $[7] = enabled;
    $[8] = projectId;
    $[9] = unitId;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== currentUnitData || $[13] !== prefillData) {
    t6 = Array.from(new Map([...(prefillData as Slot[]), ...(currentUnitData as Slot[])].map(_temp4)).values());
    $[12] = currentUnitData;
    $[13] = prefillData;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const allData = t6;
  let t7;
  if ($[15] !== prefillData) {
    t7 = slotToRange(prefillData) || {};
    $[15] = prefillData;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  const parsedTimes = t7;
  let t8;
  if ($[17] !== parsedTimes) {
    t8 = Object.keys(parsedTimes);
    $[17] = parsedTimes;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const dates = t8;
  const isOpen = Boolean(!isConfirmed && prefillData.length);
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = flag => {
      setShouldFill(flag);
      setIsConfirmed(true);
    };
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== dates || $[21] !== parsedTimes) {
    t10 = <PrefillSlotsComp dates={dates} handleConfirm={t9} parsedTimes={parsedTimes} />;
    $[20] = dates;
    $[21] = parsedTimes;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== isOpen || $[24] !== t10) {
    t11 = <SlotSheetOverLay isOpen={isOpen} onClose={_temp5}>{t10}</SlotSheetOverLay>;
    $[23] = isOpen;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = shouldFill ? allData : currentUnitData;
  let t13;
  if ($[26] !== counterSlots || $[27] !== loading || $[28] !== props || $[29] !== t12) {
    t13 = <SlotVisit {...{
      ...props,
      loading,
      counterSlots,
      prefill: t12
    }} />;
    $[26] = counterSlots;
    $[27] = loading;
    $[28] = props;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t11 || $[32] !== t13) {
    t14 = <>{t11}{t13}</>;
    $[31] = t11;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
}
function _temp5() {}
function _temp4(item) {
  return [item.start.toString(), item];
}
function _temp3(error) {
  logger.error("error fetching buyer availability", error);
}
function _temp2(slot_0) {
  return {
    start: new Date(slot_0.startTime),
    end: new Date(slot_0.endTime)
  };
}
function _temp(group) {
  return group.relationship === "buyer";
}